import React from 'react'
import PropTypes from 'prop-types'
import { GridWrapper, GridItem } from '@sainsburys-tech/grid'
import M032 from '../M032/M032'
import { ComponentHelper } from '../../../helpers/ComponentHelper'
import { M035Props } from './types'

/**
 * - M035 is a category signposts component.
 * - It has repeatable link buttons that sit in a group.
 * - They are intended to link to canned searches (e.g. 'Under £20')
 */
const M035 = ({ backgroundColor, kind, links, linkTarget, onLinkClick }: M035Props): React.ReactElement => {
  const signpostLength = links.length
  if (signpostLength < 2 || signpostLength > 9) return null

  return (
    <GridWrapper testid='m035-container' gap='lg' cols={12}>
      {links.map((signpost, index) => {
        const signPostSize = ComponentHelper.gridLayout('M035', index, signpostLength)
        return (
          <GridItem
            colSpan={{ sm: 12, ...signPostSize }}
            data-test={`m035-button-${index}-container`}
            key={`m035-signpost-${index}`}
          >
            <M032
              backgroundColor={backgroundColor}
              ctaCopy={signpost.linkName}
              linkTarget={linkTarget}
              linkUrl={signpost.linkUrl}
              linkTitle={signpost.linkTitle}
              onLinkClick={onLinkClick}
              kind={kind}
              full
              noMargin
            />
          </GridItem>
        )
      })}
    </GridWrapper>
  )
}

M035.propTypes = {
  /** Required color of the buttons' background */
  backgroundColor: PropTypes.string.isRequired,
  /** Type of button, defaults to primary */
  kind: PropTypes.oneOf(['primary', 'secondary']).isRequired,
  /** Required array of links for buttons */
  links: PropTypes.array.isRequired,
  /** Option of opening in a new tab, defaults to an empty string  */
  linkTarget: PropTypes.oneOf(['', '_blank', '_self']),
  /** Optional function to handle CTA click */
  onLinkClick: PropTypes.func
}

M035.defaultProps = {
  linkTarget: '',
  onLinkClick: null
}

export default M035
